// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__w3onS {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.styles_card__oBzDE {
  border-radius: 8px;
  box-shadow: 1px 1px 8px 2px #c6c6c6;
  overflow: auto;
  padding: 0.5rem;
  position: relative;
  width: 25rem;
}

.styles_gridContainer__Ps\\+xD {
  height: 40vh;
  overflow: auto;
  padding: 1rem;
  width: 100% !important;
}

.styles_header__YIyMm {
  background-color: #18316e;
  height: 0.3rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.styles_itemCard__wIfjk {
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
}

.styles_containerBtn__7AZ1f {
  align-items: center;
  background: #18316e;
  bottom: 0;
  border-top: 1px solid #18316e;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  width: 100%;
}

.styles_btnDropdown__afB8b {
  align-items: center !important;
  color: #fff !important;
  display: flex !important;
  gap: 0.5rem !important;
  width: 100%;
}

@media (max-width: 525px) {
  .styles_card__oBzDE {
    width: 20rem;
  }
}
@media (max-width: 445px) {
  .styles_card__oBzDE {
    width: 18rem;
  }
}
@media (max-width: 415px) {
  .styles_card__oBzDE {
    width: 15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TableCardResumo/CardViewResumo/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.card {\n  border-radius: 8px;\n  box-shadow: 1px 1px 8px 2px #c6c6c6;\n  overflow: auto;\n  padding: 0.5rem;\n  position: relative;\n  width: 25rem;\n}\n\n.gridContainer {\n  height: 40vh;\n  overflow: auto;\n  padding: 1rem;\n  width: 100% !important;\n}\n\n.header {\n  background-color: #18316e;\n  height: 0.3rem;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.itemCard {\n  white-space: nowrap;\n  display: inline-block;\n  max-width: 100%;\n}\n\n.containerBtn {\n  align-items: center;\n  background: #18316e;\n  bottom: 0;\n  border-top: 1px solid #18316e;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  width: 100%;\n}\n\n.btnDropdown {\n  align-items: center !important;\n  color: #fff !important;\n  display: flex !important;\n  gap: 0.5rem !important;\n  width: 100%;\n}\n\n@media (max-width: 525px) {\n  .card {\n    width: 20rem;\n  }\n}\n@media (max-width: 445px) {\n  .card {\n    width: 18rem;\n  }\n}\n@media (max-width: 415px) {\n  .card {\n    width: 15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__w3onS`,
	"card": `styles_card__oBzDE`,
	"gridContainer": `styles_gridContainer__Ps+xD`,
	"header": `styles_header__YIyMm`,
	"itemCard": `styles_itemCard__wIfjk`,
	"containerBtn": `styles_containerBtn__7AZ1f`,
	"btnDropdown": `styles_btnDropdown__afB8b`
};
export default ___CSS_LOADER_EXPORT___;
